import { StorageHelper } from '@smg-real-estate/hg-search-libs';

import { getUserLoginInfo } from '@/helpers/Authentication/authClient';
import { getTenantPlusSubscription } from '@/helpers/Authentication/tenantPlusAuth';
import { UserLoginInfo } from '@/helpers/Authentication/types';
import { getTenantPlusCookiesValue } from '@/helpers/CookiesHelper';
import { StorageNamespace } from '@/helpers/storage-namespaces';
import { HgLocalStorageKey } from '@/models/HgLocalStorageKey';

export const LOGIN_STATUS_LOGGED_OUT = {
  client_login_status: 'loggedout',
};

export async function getLoginStatusParameters(): Promise<Record<string, string | undefined>> {
  let userLoginInfo: UserLoginInfo | undefined;
  try {
    userLoginInfo = await getUserLoginInfo();
  } catch (ex) {
    // do silent catch
  }

  if (!userLoginInfo) {
    return LOGIN_STATUS_LOGGED_OUT;
  }

  let tenantPlusSubscriber: string | undefined = undefined;

  if (getTenantPlusCookiesValue()) {
    const tenantPlusStorageHelper = new StorageHelper(StorageNamespace.tenantPlus);
    let tenantPlusSubscription = tenantPlusStorageHelper.getLocalStorageExpirableItem(
      HgLocalStorageKey.TENANT_PLUS_SUPSCRIPTION_CACHE,
    );

    if (!tenantPlusSubscription) {
      tenantPlusSubscription = await getTenantPlusSubscription();
    }
    if (tenantPlusSubscription?.subscriptionState === 'created') {
      const currentDate = new Date().toISOString().substring(0, 10);

      tenantPlusSubscriber =
        tenantPlusSubscription.startDate > currentDate
          ? 'user_tenantplus_trial'
          : 'user_tenantplus_paid';
    }
  }

  const storageHelper = new StorageHelper(StorageNamespace.insertionFunnel);
  const { userType } = storageHelper.getLocalStorageItem('previewUserInfo') || {};

  return {
    client_login_status: 'loggedin',
    h_client_login_user_id_036: userLoginInfo.userId,
    client_login_provider: userLoginInfo.loginProvider,
    h_is_tenant_plus_user_166: tenantPlusSubscriber,
    h_login_user_type_037: userType,
  };
}
